import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditTriggerForm from './EditTriggerForm'
import IntegrationLoader from './_load/IntegrationLoader'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TriggerLoader from './_load/TriggerLoader'

const EditTriggerModal = props => {
  return (
    <ControlledModal fullScreen disableClickOutside {...props}>
      <TriggerLoader>
        <IntegrationLoader>
          <PermissionChecker any={['createTrigger', 'editTrigger']}>
            <ModalHeader />

            <HorizontalLine thin lineColor={COLORS.light2} />
            <Separator weight={4} />
            <EditTriggerForm />
          </PermissionChecker>
        </IntegrationLoader>
      </TriggerLoader>
    </ControlledModal>
  )
}

export default EditTriggerModal
